'use client'

export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en">
      <head>
        <title>Oops! | Graftcode Academy</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          backgroundColor: '#0a0a0f',
          color: '#ffffff',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            padding: '3rem 2rem',
            maxWidth: '480px',
          }}
        >
          {/* Icon */}
          <div
            style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 2rem',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2.5rem',
            }}
          >
            🔧
          </div>

          {/* Title */}
          <h1
            style={{
              fontSize: '1.75rem',
              fontWeight: 600,
              margin: '0 0 1rem',
              color: '#ffffff',
            }}
          >
            Something went wrong
          </h1>

          {/* Description */}
          <p
            style={{
              fontSize: '1rem',
              lineHeight: 1.6,
              color: '#a0a0a0',
              margin: '0 0 2rem',
            }}
          >
            We encountered an unexpected issue. Don&apos;t worry, our team has been notified. Please try again or return
            to the homepage.
          </p>

          {/* Buttons */}
          <div
            style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <button
              onClick={reset}
              style={{
                padding: '0.75rem 1.5rem',
                fontSize: '0.9375rem',
                fontWeight: 500,
                backgroundColor: '#6366f1',
                color: '#ffffff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#4f46e5')}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#6366f1')}
            >
              Try again
            </button>
            <a
              href="/"
              style={{
                padding: '0.75rem 1.5rem',
                fontSize: '0.9375rem',
                fontWeight: 500,
                backgroundColor: 'transparent',
                color: '#a0a0a0',
                border: '1px solid #333',
                borderRadius: '8px',
                cursor: 'pointer',
                textDecoration: 'none',
                transition: 'border-color 0.2s, color 0.2s',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#555'
                e.currentTarget.style.color = '#ffffff'
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#333'
                e.currentTarget.style.color = '#a0a0a0'
              }}
            >
              Go to homepage
            </a>
          </div>
        </div>
      </body>
    </html>
  )
}
